<template>
  <div
    :class='`fygr-icon-button bg-${background} clr-${color} hov-${hover}`'
    @click="$emit('click', $event)"
  >
    <i :class='`fi-${icon}`' />
  </div>
</template>
<script>
export default {
  name: 'IconButton',
  props: {
    color: String,
    hover: String,
    icon: String,
    background: String,
  },
};
</script>
<style lang='scss' scoped>
.fygr-icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  &.bg-blue {
    background-color: rgba($blue, .15);
    &:hover {
      background-color: rgba($blue, .25);
    }
  }
  &.hov-blue {
    &:hover {
      i {
        color: $blue;
      }
    }
  }
  &.clr-blue {
    i {
      color: $blue;
    }
  }
  &.bg-red {
    background-color: rgba($red, .15);
    &:hover {
      background-color: rgba($red, .25);
    }
  }
  &.hov-red {
    &:hover {
      i {
        color: $red;
      }
    }
  }
  &.clr-red {
    i {
      color: $red;
    }
  }
  &.bg-gray {
    background-color: rgba($gray, .15);
    &:hover {
      background-color: rgba($gray, .25);
    }
  }
  &.hov-gray {
    &:hover {
      i {
        color: $gray;
      }
    }
  }
  &.clr-gray {
    i {
      color: $gray;
    }
  }
  i {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }
}
</style>
